import * as React from 'react'

import {
  Tooltip,
  EXTRA_SMALL_ICON_BASE_SRC
} from '../../../../../Shared/index'

const ellipsesIcon = <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/ellipses.svg`} />

const ActivityPackHeader = ({ name, activityPackId, activityCount, handleSelectAllClick, style, }) => {
  return (
    <div aria-label={name} className="recommendation-header" key={name} style={style || {}}>
      <div className="name-and-tooltip">
        <span>{name}</span>
        <a aria-label="Preview the activity pack" className="focus-on-light" href={`/activities/packs/${activityPackId}`} rel="noopener noreferrer" target="_blank"><img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/help.svg`} /></a>
      </div>
      <div className="activity-count-and-select-all">
        <span className="activity-count">{activityCount} {activityCount === 1 ? 'activity' : 'activities'}</span>
        <Tooltip
          isTabbable={false}
          tooltipText="Select all in column"
          tooltipTriggerText={<button aria-label="Select all in column" className="interactive-wrapper" onClick={handleSelectAllClick} type="button">{ellipsesIcon}</button>}
        />
      </div>
    </div>
  )
}

export default ActivityPackHeader
